import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=3922a320&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=3922a320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922a320",
  null
  
)

export default component.exports